import React, { useState } from 'react';
import { Shield, Server, Settings, Cloud, ChevronDown, Phone, Mail, MapPin } from 'lucide-react';
import Header from "./header";
import Footer from "./footer";
const Clouds = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const services = [
    {
      icon: <Settings className="w-8 h-8 text-blue-500" />,
      title: "Cloud Consulting",
      description: "Build Enterprise SaaS Cloud Strategy with Cloud Computing, Cloud Assessment for Infrastructure, Application, DevOps"
    },
    {
      icon: <Cloud className="w-8 h-8 text-blue-500" />,
      title: "Cloud Native Application",
      description: "Architect, design and build cloud native applications on multi-cloud platform systems"
    },
    {
      icon: <Server className="w-8 h-8 text-blue-500" />,
      title: "SaaS Services: Consulting",
      description: "Azure application architecture, development, consulting for SaaS and creating a new application"
    },
    {
      icon: <Shield className="w-8 h-8 text-blue-500" />,
      title: "Cloud Platform Services",
      description: "Design, integrate multi-cloud solutions, DevOps & CI/CD Services"
    }
  ];

  const reasons = [
    "A Experience of 10+ Cloud Consultants with 500+ person-years of experience",
    "Deep understanding of application platform based on past assessments and engagements",
    "Time tested and proven cloud reference architectures for varied industries",
    "Reference Architecture Libraries for applications and infrastructure",
    "Automated Unified Assessment Tool",
    "Strong governance to ensure collaboration between cloud platforms and on-premise infrastructure"
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <Header />
   {/* Hero Section - Dark */}
   
       <section className="bg-gradient-to-r from-blue-50 to-indigo-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Support <span className="text-blue-600">Cloud</span> Offerings
              </h2>
              <p className="text-lg text-gray-700 mb-8">
                Many enterprises recognize the cloud's potential but struggle to 
                envision its impact and develop a clear strategy. Anvitech 
                Solutions bridges this gap with expert cloud-native services, 
                offering everything from guidance and best practices to execution.
              </p>
              <button className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 font-semibold transition-colors">
                Schedule A Call
              </button>
            </div>
            <div className="relative">
              <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg p-12 text-white relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20"></div>
                <div className="relative z-10 flex items-center justify-center">
                  <div className="text-center">
                    <div className="text-6xl font-bold mb-2">aws</div>
                    <div className="text-2xl text-blue-400">→</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

 {/* Services Grid - Dark */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-white mb-4">
              Our <span className="text-blue-400">Cloud Services</span>
            </h3>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Comprehensive cloud solutions tailored to your business needs
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div key={index} className="text-center p-6 bg-gray-800 rounded-lg hover:shadow-lg transition-all hover:bg-gray-700">
                <div className="flex justify-center mb-4">
                  {service.icon}
                </div>
                <h4 className="text-xl font-semibold text-white mb-3">{service.title}</h4>
                <p className="text-gray-300 text-sm">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* About Section - Light */}
      <section className="py-20 bg-gradient-to-r from-blue-50 to-indigo-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg p-8">
              <Cloud className="w-16 h-16 mb-4 text-blue-200" />
              <div className="space-y-4">
                <div className="bg-blue-500 h-8 rounded"></div>
                <div className="bg-blue-400 h-6 rounded w-3/4"></div>
                <div className="bg-blue-300 h-6 rounded w-1/2"></div>
              </div>
            </div>
            <div>
              <h3 className="text-3xl font-bold mb-6 text-gray-900">
                About Our <span className="text-blue-600">Support Cloud</span> Offerings
              </h3>
              <p className="text-gray-700 mb-6">
                Enterprises are abandoning traditional on-premise cost from 
                Data IT infrastructure and move to a more agile infrastructure 
                which is not only cost-effective but also helps them focus on their 
                core business areas.
              </p>
              <p className="text-gray-700 mb-6">
                While enterprises are aware that the great part of their worry can 
                be solved by migrating to the cloud but they always face a 
                challenge on "What can the Cloud do for them" becomes difficult 
                for enterprises to have one cohesive view of what cloud can do for 
                them.
              </p>
              <div className="space-y-4">
                <div className="border-l-4 border-blue-600 pl-4">
                  <h4 className="font-semibold text-gray-900">DAY (1): Assessment & Advisory Services</h4>
                  <p className="text-gray-600">Cloud advisory services, assessment and roadmap development</p>
                </div>
                <div className="border-l-4 border-blue-600 pl-4">
                  <h4 className="font-semibold text-gray-900">DAY (2): Design, Designing application architecture</h4>
                  <p className="text-gray-600">Cloud services, platform, security and goals</p>
                </div>
                <div className="border-l-4 border-blue-600 pl-4">
                  <h4 className="font-semibold text-gray-900">DAY (3): Support, Deploy, Automate & manage</h4>
                  <p className="text-gray-600">Application and Infrastructure analytics, implement cloud computing platforms</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     
   {/* Migration Advantages Section - Dark */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-white mb-4">
              <span className="text-blue-400">Key advantages for enterprises</span> to migrate their IT infrastructure
            </h3>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Transform your business with cloud migration benefits
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gray-800 rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow hover:bg-gray-700">
              <div className="bg-blue-600 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <Settings className="w-8 h-8 text-white" />
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">
                Manage the IT resources better and focus on your core business
              </h4>
            </div>
            <div className="bg-gray-800 rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow hover:bg-gray-700">
              <div className="bg-blue-600 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">
                Access to Global resources without worrying of IT failure or sudden spike in business demand or sudden ramp down
              </h4>
            </div>
            <div className="bg-gray-800 rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow hover:bg-gray-700">
              <div className="bg-blue-600 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <Server className="w-8 h-8 text-white" />
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">
                Reduction in overall Operational and Management Cost as cloud gives the options of pay as you go and pay as per usage
              </h4>
            </div>
            <div className="bg-gray-800 rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow hover:bg-gray-700">
              <div className="bg-blue-600 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <Cloud className="w-8 h-8 text-white" />
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">
                Offload the management and availability responsibilities to a specialised cloud service provider
              </h4>
            </div>
          </div>
        </div>
      </section> 
      {/* Cloud Migration Section - Light */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="bg-gradient-to-br from-blue-600 to-purple-600 rounded-full w-80 h-80 mx-auto relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500/30 to-purple-500/30"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <Cloud className="w-32 h-32 text-white/80" />
              </div>
            </div>
            <div>
              <h3 className="text-3xl font-bold mb-6 text-gray-900">
                Amazon Web Services: <span className="text-blue-600">Cloud Migration</span>
              </h3>
              <p className="text-gray-700 mb-6">
                Anvitech is a specialist when it comes to cloud migration 
                services, consulting, deployment and solutions. We have helped 
                various enterprises in porting their existing systems plan strategy 
                and proper deployment for your success. Following steps are 
                followed to execute the process of cloud migration:
              </p>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">Analyze challenges and risks before moving to AWS cloud platform</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">Evaluate existing IT infrastructure and software ecosystem to identify which system and workload is best suited for migrating to cloud</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">Identify applications which will be more valuable by migrating them to the cloud</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">Identify the cloud service provider best suited for the client's service requirements</span>
                </li>
              </ul>
              <p className="text-gray-700">
                Our AWS specialist consultants work closely with the client's team 
                and perform a detailed review of IT infrastructure and provide 
                recommendations for cloud migration along with the following 
                services.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <Footer/>
    </div>
  );
};

export default Clouds;